import React from 'react';
import type { ClientInvoiceViewModel } from '../../lib/clientInvoiceTemplate';
import { getInvoiceLogoDisplayUrl } from '../../lib/clientInvoiceTemplate';

interface ClientInvoiceHeaderProps {
  viewModel: ClientInvoiceViewModel;
}

const ClientInvoiceHeader: React.FC<ClientInvoiceHeaderProps> = ({ viewModel: vm }) => {
  const logoSrc = vm.logoDataUrl || getInvoiceLogoDisplayUrl(vm.logoUrl);

  return (
    <header className="mb-6 flex flex-wrap items-start justify-between gap-4 border-b border-pink-100 pb-5">
      <div className="flex min-w-0 flex-1 items-start gap-4">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={`${vm.businessName} logo`}
            className="h-16 w-auto max-w-[140px] object-contain"
          />
        ) : null}
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-gray-900">{vm.businessName}</h1>
          {vm.businessAddress ? (
            <p className="mt-1 whitespace-pre-line text-sm text-gray-600">{vm.businessAddress}</p>
          ) : null}
          {vm.businessGstNumber ? (
            <p className="mt-1 text-sm text-gray-600">GST #{vm.businessGstNumber}</p>
          ) : null}
          {vm.businessPhone ? (
            <p className="text-sm text-gray-500">{vm.businessPhone}</p>
          ) : null}
        </div>
      </div>
      <div className="text-right text-sm text-gray-700">
        <p className="text-lg font-bold text-pink-700">Tax Invoice</p>
        <p className="mt-1">
          <span className="text-gray-500">Invoice #</span> {vm.invoiceNumber}
        </p>
      </div>
    </header>
  );
};

export default ClientInvoiceHeader;
